import styled, { css } from 'styled-components';

export const Container = styled.div``;

/* Main player area */
export const PlayerWrapper = styled.div`
  position: relative;
  padding-bottom: 56.25%;
  padding-top: 0;
  height: 0;
  overflow: hidden;
  border-radius: 14px;
  margin-bottom: 18px;
  background: #0a0a0a;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

/* Carousel container */
export const CarouselWrapper = styled.div`
  position: relative;
`;

export const CarouselArrow = styled.button<{ $direction: 'left' | 'right' }>`
  position: absolute;
  ${({ $direction }) => ($direction === 'left' ? 'left: -6px' : 'right: -6px')};
  top: 50%;
  transform: translateY(-50%);
  width: 32px;
  height: 32px;
  border-radius: 50%;
  z-index: 3;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(6px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.15);
  }
`;

export const CarouselScroll = styled.div`
  display: flex;
  gap: 10px;
  padding: 2px 4px;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const VideoThumbnail = styled.button<{
  $active: boolean;
  $color: string;
}>`
  ${({ $active, $color }) => css`
    width: 200px;
    min-width: 200px;
    height: 115px;
    border-radius: 12px;
    overflow: hidden;
    background: #0d1117;
    border: 2px solid ${$active ? $color : 'rgba(255, 255, 255, 0.06)'};
    display: flex;
    position: relative;
    scroll-snap-align: start;
    cursor: pointer;
    padding: 0;
    font-family: inherit;
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.03);
      border-color: ${$active ? $color : 'rgba(255, 255, 255, 0.25)'};
    }
  `}
`;

export const ThumbnailImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

export const ThumbnailOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.75) 0%, transparent 60%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const ThumbnailPlayIcon = styled.div<{
  $active: boolean;
  $color: string;
}>`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: ${({ $active, $color }) =>
    $active ? `${$color}55` : 'rgba(255, 255, 255, 0.15)'};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  backdrop-filter: blur(4px);
`;

export const ThumbnailInfo = styled.div<{ $active: boolean }>`
  padding: 0 10px;
  text-align: center;
  width: 100%;

  > div:first-child {
    font-size: 11px;
    font-weight: 600;
    color: ${({ $active }) => ($active ? 'white' : 'rgba(255, 255, 255, 0.7)')};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const ActiveIndicator = styled.div<{ $color: string }>`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: ${({ $color }) => $color};
  border-radius: 0 0 10px 10px;
`;
